import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";

const VendorReport = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/vendors");
      setData(res.data);
    } catch (err) {
      console.error("Error loading vendor report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (!data) return <p>Loading vendor report...</p>;

  return (
    <div className="report-vendors space-y-4">
      <h2 className="text-xl font-bold">Vendor Performance Reports</h2>

      <div className="p-4 bg-white rounded shadow">
        <h3 className="font-semibold mb-2">Seller Ratings</h3>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Number of Products</th>
              <th>Number of Orders</th>
              <th>Income</th>
              <th>Average Order Value</th>
            </tr>
          </thead>
          <tbody>
            {data.map((vendor) => (
              <tr key={vendor._id}>
                <td>{vendor.name}</td>
                <td>{vendor.productCount}</td>
                <td>{vendor.orderCount}</td>
                <td>${vendor.revenue}</td>
                <td>${vendor.aov}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorReport;
